import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DPCustomer } from './dp-customer';
import { DPCustomerService } from './dp-customer.service';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';

@Component({
    templateUrl: 'dp-customer-create.component.html'
})
export class DPCustomerCreateComponent implements OnInit {
    @Input() customer: DPCustomer;
    @Output() close = new EventEmitter();
    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    storedStatus: number;
    isFirst: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;


    constructor(
        private toasterService: ToasterService,

        private _service: NotificationsService,
        private router: Router,
        private customerService: DPCustomerService,
        private route: ActivatedRoute) {
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    ngOnInit() {

        this.customer = new DPCustomer();
        this.storedStatus = 1;
        this.isFirst = true;

    }
    save1(customer: DPCustomer, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            this.submitting = true;
            customer.status = this.storedStatus;
            this.save(customer);
        }
    }

    checkStatus() {
        if (this.storedStatus == 0) {
            this.storedStatus = 1;
        }
        else {
            this.storedStatus = 0;
        }
    }


    save(customer: DPCustomer) {
        this.customer = customer;
        this.customerService
            .createCustomer(this.customer)
            .then(customer => {
                this.customer = customer; // saved hero, w/ id if new
                this.goBack();
            })
            .catch(error => this.errorHandler(error));
    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer']);

        }
    }


    public activeStatus = [
        { value: 0, display: 'Inactive' },
        { value: 1, display: 'Active' },
    ];

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-customer-create.component.ts